import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import BookTable from '../BookTable';
import { useBook } from '../../Context/BookContext';

const LibraryPage: React.FC = () => {
  const navigate = useNavigate();
  const { setSelectedBook, setLastUploadedBook } = useBook();

  const handleUploadNewBook = () => {
    // Clear any selected book and last uploaded book, then navigate to upload stage
    setSelectedBook(null);
    setLastUploadedBook(null);
    navigate('/process-book/upload');
  };

  const handleSelectBook = (book: any) => {
    setSelectedBook(book);
    // Navigate to stage 4 (Download/Read) when clicking a book row
    navigate('/process-book/download-read');
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ 
        mb: 4, 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between', 
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 2
      }}>
        <Box>
          <Typography variant="h4" sx={{ color: 'text.primary', mb: 1, fontWeight: 700, fontSize: { xs: '1.75rem', md: '2.125rem' } }}>
            Library
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Manage your books and start the illustration process
          </Typography>
        </Box>

        {/* Upload New Book Button */}
        <Button
          variant="contained"
          size="large"
          startIcon={<Add />}
          onClick={handleUploadNewBook}
          fullWidth={false}
          sx={{
            backgroundColor: 'primary.main',
            '&:hover': { 
              backgroundColor: 'primary.dark',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(116, 164, 137, 0.3)'
            },
            textTransform: 'none',
            fontWeight: 600,
            py: 1.5,
            px: 3,
            fontSize: '1rem',
            transition: 'all 0.3s ease',
            minWidth: { xs: '100%', sm: 'auto' },
          }}
        >
          Upload New Book
        </Button>
      </Box>

      {/* Book Table */}
      <Box sx={{ 
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden'
      }}>
        <Box sx={{ 
          p: 2, 
          backgroundColor: 'action.hover',
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}>
          <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 600 }}>
            📚 Your Books
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <BookTable onSelectBook={handleSelectBook} />
        </Box>
      </Box>
    </Box>
  );
};

export default LibraryPage; 

